import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.ValidationRulesServiceProxy,        
        ApiServiceProxies.SycCurrencyExchangeRatesServiceProxy,        
        ApiServiceProxies.AppTenantInvoicesServiceProxy,        
        ApiServiceProxies.AppTenantActivitiesLogServiceProxy,        
        ApiServiceProxies.AppTenantSubscriptionPlansServiceProxy,        
        ApiServiceProxies.AppSubscriptionPlanHeadersServiceProxy,        
        ApiServiceProxies.AppSubscriptionPlanDetailsServiceProxy,        
        ApiServiceProxies.AppFeaturesServiceProxy,        
        ApiServiceProxies.MaintainancesServiceProxy,        
        ApiServiceProxies.SycIdentifierDefinitionsServiceProxy,        
        ApiServiceProxies.SycSegmentIdentifierDefinitionsServiceProxy,        
        ApiServiceProxies.SycCountersServiceProxy,        
        ApiServiceProxies.SycAttachmentTypesServiceProxy,        
        ApiServiceProxies.AppAdvertisementsServiceProxy,        
        ApiServiceProxies.AppItemsListsServiceProxy,
        ApiServiceProxies.TicketNotesServiceProxy,
        ApiServiceProxies.TicketsServiceProxy,
        ApiServiceProxies.AppTenantsActivitiesLogsServiceProxy,
        ApiServiceProxies.AppTenantPlansServiceProxy,
        ApiServiceProxies.AppTransactionsServiceProxy,
        ApiServiceProxies.SycPlanServicesServiceProxy,
        ApiServiceProxies.SycPlansServiceProxy,
        ApiServiceProxies.SycServicesServiceProxy,
        ApiServiceProxies.SycApplicationsServiceProxy,
        ApiServiceProxies.AppItemsServiceProxy,
        ApiServiceProxies.SycAttachmentCategoriesServiceProxy,
        ApiServiceProxies.AccountsServiceProxy,
        ApiServiceProxies.SuiIconsServiceProxy,
        ApiServiceProxies.MessageServiceProxy,
        ApiServiceProxies.AppEntitiesServiceProxy,
        ApiServiceProxies.SycEntityObjectClassificationsServiceProxy,
        ApiServiceProxies.SycEntityObjectStatusesServiceProxy,
        ApiServiceProxies.SycEntityObjectCategoriesServiceProxy,
        ApiServiceProxies.SycEntityObjectTypesServiceProxy,
        ApiServiceProxies.SydObjectsServiceProxy,
        ApiServiceProxies.SysObjectTypesServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        // ApiServiceProxies.DynamicParameterServiceProxy,
        // ApiServiceProxies.DynamicEntityParameterDefinitionServiceProxy,
        // ApiServiceProxies.EntityDynamicParameterServiceProxy,
        // ApiServiceProxies.DynamicParameterValueServiceProxy,
        // ApiServiceProxies.EntityDynamicParameterValueServiceProxy,
        ApiServiceProxies.SycReportsServiceProxy,
        ApiServiceProxies.AppPostsServiceProxy,
        ApiServiceProxies.AutotaskQueuesServiceProxy, 
        ApiServiceProxies.AppItemSelectorsServiceProxy, 
        ApiServiceProxies.AppSizeScaleServiceProxy, 
        ApiServiceProxies.AppItemStockAvailabilityServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
